module.exports = __webpack_public_path__ + "static/media/Ball2.a5223294.png";